import { render, staticRenderFns } from "./QuatationInvoiceAddr.vue?vue&type=template&id=75206998&scoped=true&"
import script from "./QuatationInvoiceAddr.vue?vue&type=script&lang=js&"
export * from "./QuatationInvoiceAddr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75206998",
  null
  
)

export default component.exports